<template>
  <div>
    <el-button type="primary" @click="openSee">
      <slot></slot>
    </el-button>

    <el-drawer
        title="入库操作"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="false"
        :before-close="closeSee"
    >
      <div style="padding: 20px;">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form>
              <el-form-item label="入库信息">
                <el-input type="textarea" v-model="formInJson" :rows="20" placeholder='请输入入库信息，例如：[{"mcu":"...","bar_code":"..."}]'></el-input>
              </el-form-item>
              <div style="padding-bottom: 10px;font-size: 12px;color: #666666;">入库格式：[{"mcu":"...","bar_code":"..."}]</div>
              <el-form-item>
                <el-button type="primary" v-loading="submitIng" @click="toSubmit">提交</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-collapse v-model="collapseIndex">
              <el-collapse-item :title="'入库成功信息：' + success.length" name="success">
                <el-table :data="success" border style="width: 100%">
                  <el-table-column prop="mcu" label="MCU"></el-table-column>
                  <el-table-column prop="bar_code" label="条码"></el-table-column>
                </el-table>
              </el-collapse-item>
              <el-collapse-item :title="'MCU已经绑定：' + fault_mcu_bind.length" name="fault_mcu_bind">
                <el-table :data="fault_mcu_bind" border style="width: 100%">
                  <el-table-column prop="mcu" label="MCU"></el-table-column>
                  <el-table-column prop="bar_code" label="条码"></el-table-column>
                </el-table>
              </el-collapse-item>
              <el-collapse-item :title="'条码已绑定：'+ fault_bar_code_bind.length" name="fault_bar_code_bind">
                <el-table :data="fault_bar_code_bind" border style="width: 100%">
                  <el-table-column prop="mcu" label="MCU"></el-table-column>
                  <el-table-column prop="bar_code" label="条码"></el-table-column>
                </el-table>
              </el-collapse-item>
              <el-collapse-item :title="'条码不存在错误：' + fault_bar_code_notfound.length" name="fault_bar_code_notfound">
                <el-table :data="fault_bar_code_notfound" border style="width: 100%">
                  <el-table-column prop="mcu" label="MCU"></el-table-column>
                  <el-table-column prop="bar_code" label="条码"></el-table-column>
                </el-table>
              </el-collapse-item>
              <el-collapse-item :title="'MCU已在库存：' + fault_inventory_mcu_had.length" name="fault_inventory_mcu_had">
                <el-table :data="fault_inventory_mcu_had" border style="width: 100%">
                  <el-table-column prop="mcu" label="MCU"></el-table-column>
                  <el-table-column prop="bar_code" label="条码"></el-table-column>
                </el-table>
              </el-collapse-item>
              <el-collapse-item :title="'条码已在库存：' + fault_inventory_bar_code_had.length" name="fault_inventory_bar_code_had">
                <el-table :data="fault_inventory_bar_code_had" border style="width: 100%">
                  <el-table-column prop="mcu" label="MCU"></el-table-column>
                  <el-table-column prop="bar_code" label="条码"></el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      openStatus: false,
      formInJson: '',
      form: {
        entity: [],
      },
      submitIng: false,
      success: [],
      fault_mcu_bind: [],
      fault_bar_code_bind: [],
      fault_bar_code_notfound: [],
      fault_inventory_mcu_had: [],
      fault_inventory_bar_code_had: [],
      collapseIndex: 'success'
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {},
  mounted() {
  },
  methods: {
    openSee() {
      const _this = this;
      _this.form = {
        entity: [],
      }
      _this.openStatus = true;
    },
    closeSee() {
      const _this = this;
      _this.form = {
        entity: [],
      }
      _this.openStatus = false;
      _this.$emit('finish', {});
    },
    // 获取列表
    toSubmit() {
      const _this = this;
      _this.submitIng = true;
      _this.form.entity = JSON.parse(_this.formInJson);
      _this.$api.wareInSubmit(_this.form)
          .then(res => {
            _this.submitIng = false;
            _this.success = res.success;
            _this.fault_mcu_bind = res.fault_mcu_bind;
            _this.fault_bar_code_bind = res.fault_bar_code_bind;
            _this.fault_bar_code_notfound = res.fault_bar_code_notfound;
            _this.fault_inventory_mcu_had = res.fault_inventory_mcu_had;
            _this.fault_inventory_bar_code_had = res.fault_inventory_bar_code_had;
            _this.$message.error('提交成功，请查看右边返回结果');
          })
          .catch(err => {
            _this.submitIng = false;
            _this.$message.error(err.msg);
          })
    },
  },
};
</script>